var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cross",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cross-1",
    d: "M38,10 L38,27 L54,27 L54,38 L38,38 L38,54 L27,54 L27,38 L10,38 L10,27 L27,27 L27,10 L38,10 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cross-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross-3",
    transform: "translate(-12.000000, -12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross-4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cross-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    id: "cross-6",
    xlinkHref: "#cross-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "cross-7",
    className: "fill-selector",
    fill: "#151515",
    transform: "translate(32.000000, 32.000000) rotate(45.000000) translate(-32.000000, -32.000000) ",
    xlinkHref: "#cross-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.1fdb3efdf11d2d19e360cad237b0a178.svg";
export { ForwardRef as ReactComponent };